import { Stack, Typography } from '@mui/material';
import theme from '@/app/theme';

const ContentsContainer = ({
  primaryText,
  secondaryText,
  isError = false,
  children
}: {
  primaryText: string | JSX.Element;
  secondaryText: string | JSX.Element;
  isError?: boolean;
  children?: JSX.Element;
}) => {
  return (
    <>
      <Stack gap="8px" alignItems="flex-start">
        <Typography variant="subtitle2" textAlign="left" color={isError ? theme.palette.error.dark : theme.palette.gray[800]} fontWeight={600}>
          {primaryText}
        </Typography>
        <Stack>
          {typeof secondaryText === 'string'
            ? secondaryText.split('\n').map((text, i) => (
                <Typography key={`text-${i}`} variant="body1" textAlign="left" marginX="auto" color={theme.palette.gray[600]} fontWeight={400}>
                  {text}
                </Typography>
              ))
            : secondaryText}
        </Stack>
      </Stack>
      {children}
    </>
  );
};

export default ContentsContainer;
